import React, { useState, useEffect } from "react";
import { CustomerInfo } from "./CustomerInfo";
import "./CustomerPaymentInfo.css";
import { PaymentInfo } from "./PaymentInfo";
import { useLocation } from "react-router-dom";
import { showtoast } from "../Utilities/Utilities";
import { validateMobile } from "../Utilities/InputValidations";
import { LeadSubmitDetails } from "../Utilities/LeadSubmitDetails";
import { LeadSuccessModal } from "../Utilities/LeadSuccessModal";
import { mySweetAlert } from "../Utilities/Utilities";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;
const feBaseURL = process.env.REACT_APP_FE_URL || `${window.location.origin}`;

export const CustomerPaymentInfo = () => {
  const location = useLocation();
  const { finalCart, allCartSummary, isTokenValid, reqParams } =
    location?.state || {};

  const [activePaymentBtn, setActivePaymentBtn] = useState(false);
  const [oTPSentResult, setOTPSentResult] = useState();
  const [oTPVerifyResult, setOTPVerifyResult] = useState();
  const [oTPbtn, setOTPbtn] = useState(true);
  const [otpCountdn, setOTPCountdn] = useState(120);
  const [isOTPInputVisible, setIsOTPInputVisible] = useState(false);

  const [emailOTPSentResult, setEmailOTPSentResult] = useState();
  const [emailOTPVerifyResult, setEmailOTPVerifyResult] = useState();
  const [emailOTPbtn, setEmailOTPbtn] = useState(true);
  const [emailOTPCountdn, setEmailOTPCountdn] = useState(120);
  const [isEmailOTPInputVisible, setIsEmailOTPInputVisible] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [emailEditEnable, setEmailEditEnable] = useState(true);
  const [leadBuyerInfo, setLeadBuyerInfo] = useState({
    BuyerName: "",
    MobileNo: "",
  });

  const [buyerInfo, setBuyerInfo] = useState({
    BuyerID: 0,
    BuyerName: "",
    MobileNo: "",
    MobileNoVerified: false,
    EmailID: "",
    EmailIDVerified: false,
    CompanyAddress: "",
    CompanyName: "",
    IsProfileUpdated: 0,
    GSTNo: "",
    PinCode: 0,
    UserAgent: "",
    IPAddress: "",
    OTTSMSID: 0,
  });

  const updateBuyerInfo = (field, value) => {
    const mybuyerInfo = {
      ...buyerInfo,
      [field]:
        field !== "PinCode"
          ? value
          : value !== ""
            ? (parseInt(value, 10) ?? 0)
            : "",
    };
    setBuyerInfo(mybuyerInfo);
    const isValid = checkPaymentEnable(mybuyerInfo);
    setActivePaymentBtn(isValid);

    if (field === "MobileNo") {
      if (validateMobile(value)) {
        setOTPbtn(false);
      } else {
        setOTPbtn(true);
      }
    }
    if (field === "EmailID") {
      if (validateEmail(value)) {
        setEmailOTPbtn(false);
      } else {
        setEmailOTPbtn(true);
      }
    }
  };

  const validateOTP = (otp) => {
    const otpRegex = /^\d{4}$/;
    return otpRegex.test(otp);
  };

  const validateEmail = (email) => {
    var emailRegex =
      /^[^@\s]+@[^@\s]+\.(com|net|org|gov|in|co|COM|Com|NET|Net|ORG|Org|GOV|Gov|IN|In|CO|Co)$/;
    return emailRegex.test(email);
  };

  //MobileOTP
  const generateMobileOTP = (e, mobNo) => {
    e.preventDefault();
    setOTPSentResult(null);
    setOTPVerifyResult(null);
    if (!validateMobile(mobNo)) {
      showtoast("error", "Please provide valid Mobile No.");
      return;
    } else {
      setIsOTPInputVisible(true);
    }

    const request = {
      MobileNo: mobNo,
      Source: "FAF",
      ProcessType: "Mob validation",
      ClientIP: "",
    };

    generateOTP(request);
  };

  const generateOTP = (request) => {
    setOTPbtn(true);
    fetch(`${apiBaseURL}/api/FriendAndFamily/GenerateOTP`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the JSON response
      })
      .then((resultInfo) => {
        setOTPSentResult(resultInfo);
        if (resultInfo && resultInfo.resultStatus === "Success") {
          setOTPbtn(true);
          setOTPCountdn(120);
          const intervalId = setInterval(() => {
            setOTPCountdn((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
          }, 1000);

          setTimeout(() => {
            setOTPbtn(false);
            clearInterval(intervalId);
          }, 120 * 1000);
        } else {
          setOTPbtn(false);
        }
      })
      .catch((err) => {
        setOTPbtn(false);
        console.error("Error calling GenerateOTP API:", err);
      });
  };

  const verifyMobileOTP = (e, inputOTP, mobNo) => {
    e.preventDefault();
    if (!validateOTP(inputOTP)) {
      showtoast("error", "Please provide valid OTP.");
    }

    const request = {
      MobileNo: mobNo,
      OTP: inputOTP,
      Source: "FAF",
      ProcessType: "verify mob",
      ClientIP: "",
      UserAgent: "123",
    };

    verifyOTP(request);
  };

  const verifyOTP = (request) => {
    fetch(`${apiBaseURL}/api/FriendAndFamily/ValidateOTP`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the JSON response
      })
      .then((resultInfo) => {
        if (resultInfo && resultInfo.resultStatus === "Success") {
          if (request.MobileNo === resultInfo.result.mobileNo) {
            setOTPVerifyResult(resultInfo);
            const mybuyerInfo = {
              ...buyerInfo,
              BuyerID: resultInfo.result.buyerID,
              BuyerName:
                buyerInfo.BuyerName.length <= 0
                  ? resultInfo.result.buyerName
                  : buyerInfo.BuyerName,
              MobileNoVerified: true, //mobileNoVerified
              EmailID: resultInfo.result.emailID,
              EmailIDVerified: resultInfo.result.emailIDVerified,
              CompanyAddress: resultInfo.result.companyAddress,
              CompanyName: resultInfo.result.companyName,
              GSTNo: resultInfo.result.gstNo,
              PinCode:
                resultInfo.result.pinCode > 0 ? resultInfo.result.pinCode : "",
              IsProfileUpdated: resultInfo.result.isProfileUpdated,
              OTTSMSID: resultInfo.result.OTTSMSID,
            };
            setBuyerInfo(mybuyerInfo);
            const isValid = checkPaymentEnable(mybuyerInfo);
            setActivePaymentBtn(isValid);
            if (
              mybuyerInfo.EmailID !== null &&
              mybuyerInfo.EmailID !== "" &&
              mybuyerInfo.EmailIDVerified
            ) {
              setEmailEditEnable(false);
            }
          } else {
            const myResultInfo = {
              resultStatus: "Failed",
              resultCode: -1015,
              resultMessage: "Somthing Went To Wrong. Please try again.",
            };
            setOTPVerifyResult(myResultInfo);
          }
        } else {
          setOTPVerifyResult(resultInfo);
        }
      })
      .catch((err) => {
        console.error("Error calling verifyOTP API:", err);
      });
  };

  //EmailOTP
  const generateEmailOTP = (e, emailId) => {
    e.preventDefault();
    setEmailOTPSentResult(null);
    setEmailOTPVerifyResult(null);
    if (!validateEmail(emailId)) {
      showtoast("error", "Please provide valid Email Id.");
      return;
    } else {
      setIsEmailOTPInputVisible(true);
    }
    const request = {
      EmailID: emailId,
      MobileNo: buyerInfo.MobileNo,
      Source: "FAF",
      ProcessType: "email validate",
      ClientIP: "",
    };
    generateEmailVerificationCode(request);
  };

  const generateEmailVerificationCode = (request) => {
    setEmailOTPbtn(true);
    fetch(`${apiBaseURL}/api/FriendAndFamily/GenerateEmailVerificationCode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the JSON response
      })
      .then((resultInfo) => {
        setEmailOTPSentResult(resultInfo);
        if (resultInfo && resultInfo.resultStatus === "Success") {
          setEmailOTPbtn(true);
          setEmailOTPCountdn(120);
          const intervalId = setInterval(() => {
            setEmailOTPCountdn((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
          }, 1000);

          setTimeout(() => {
            setEmailOTPbtn(false);
            clearInterval(intervalId);
          }, 120 * 1000);
        } else {
          setEmailOTPbtn(false);
        }
      })
      .catch((err) => {
        setEmailOTPbtn(false);
        console.error("Error calling EmailVerification API:", err);
      });
  };

  const verifyEmailOTP = (e, inputEmailOTP, emailId) => {
    e.preventDefault();
    const request = {
      MobileNo: buyerInfo.MobileNo,
      VerificationCode: inputEmailOTP,
      Source: "FAF",
      ProcessType: "verify email",
      IPAddress: "",
      EmailID: emailId,
    };
    verifyEmailVerificationCode(request);
  };

  const verifyEmailVerificationCode = (request) => {
    fetch(`${apiBaseURL}/api/FriendAndFamily/ValidateEmailVerificationCode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        setEmailOTPVerifyResult(resultInfo);
        if (resultInfo && resultInfo.resultStatus === "Success") {
          const mybuyerInfo = {
            ...buyerInfo,
            EmailIDVerified: true,
          };
          setBuyerInfo(mybuyerInfo);
          const isValid = checkPaymentEnable(mybuyerInfo);
          setActivePaymentBtn(isValid);
        }
      })
      .catch((err) => {
        console.error("Error calling verifyEmailOTP API:", err);
      });
  };

  const submitMakePayment = (cartSummary, myFinalCart) => {
    const MYSubsPlanRequests =
      cartSummary &&
      cartSummary.length > 0 &&
      cartSummary.map((item) => {
        const data = {
          SubscriptionPlanID: item.planID,
          Quantity: item.quantity,
          PlanAmount: item.subscriptionAmount, //item.actualPayableAmount,
          DiscountPercentage: item.discountPercentage,
          DiscountValues: item.totalDiscount,
        };
        return data;
      });
    const request = {
      TransactionAmount: myFinalCart.cartValue,
      SubsPlanRequests: MYSubsPlanRequests,
      SubsPGRequest: {
        ReturnURL: `${feBaseURL}/thankyou-page`,
      },
      MobileNo: buyerInfo.MobileNo,
      BuyerID: buyerInfo.BuyerID,
      Source: "FAF",
      IPAddress: "",
      UserAgent: "AAP",
    };

    fetch(
      `${apiBaseURL}/api/FriendAndFamily/GenerateSubscriptionRequestForWatchoFF`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        if (resultInfo && resultInfo.resultStatus === "Success") {
          window.location.replace(resultInfo.result.pG_payment_links);
        } else {
          showtoast("error", resultInfo.resultMessage);
        }
      })
      .catch((err) => {
        console.error("Error calling GenerateBulkSubscriptionRequest:", err);
      });
  };

  const submitBuyerDetails = (cartSummary, myFinalCart) => {
    const reqBuyerInfo = {
      ...buyerInfo,
      PinCode: buyerInfo.PinCode !== "" ? buyerInfo.PinCode : 0,
    };

    if (reqBuyerInfo.BuyerID > 0) {
      fetch(`${apiBaseURL}/api/FriendAndFamily/ManageBuyerProfile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reqBuyerInfo),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((resultInfo) => {
          if (resultInfo && resultInfo.resultStatus === "Success") {
            submitMakePayment(cartSummary, myFinalCart);
          } else {
            showtoast("error", resultInfo.resultMessage);
          }
        })
        .catch((err) => {
          console.error("Error updating buyer profile:", err);
        });
    } else {
      showtoast("error", "Please validate mob no");
    }
  };

  const handleMakePayment = (cartSummary, myFinalCart) => {
    submitBuyerDetails(cartSummary, myFinalCart);
  };

  const checkPaymentEnable = (obj) => {
    const {
      CompanyAddress,
      CompanyName,
      GSTNo,
      PinCode,
      IsProfileUpdated,
      UserAgent,
      IPAddress,
      OTTSMSID,
      ...filteredData
    } = obj;
    return Object.values(filteredData).every((value) => {
      return value !== "" && value !== 0 && value !== false;
    });
  };

  const getBuyerdetails = (reqParams) => {
    const req = {
      MobileNo: reqParams.MobileNo,
    };

    fetch(`${apiBaseURL}/api/FriendAndFamily/GetBuyerDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(req),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        if (resultInfo && resultInfo.resultStatus === "Success") {
          const mybuyerInfo = {
            ...buyerInfo,
            BuyerID: resultInfo.result.buyerID,
            BuyerName:
              buyerInfo.BuyerName.length <= 0
                ? resultInfo.result.buyerName
                : buyerInfo.BuyerName,
            MobileNo: reqParams.MobileNo,
            MobileNoVerified: true, //mobileNoVerified
            EmailID: resultInfo.result.emailID,
            EmailIDVerified: resultInfo.result.emailIDVerified,
            CompanyAddress: resultInfo.result.companyAddress,
            CompanyName: resultInfo.result.companyName,
            GSTNo: resultInfo.result.gstNo,
            PinCode:
              resultInfo.result.pinCode > 0 ? resultInfo.result.pinCode : "",
            IsProfileUpdated: resultInfo.result.isProfileUpdated,
            OTTSMSID:
              resultInfo.result.OTTSMSID > 0
                ? resultInfo.result.OTTSMSID
                : parseInt(reqParams.OTTSMSID),
          };
          setBuyerInfo(mybuyerInfo);
          const isValid = checkPaymentEnable(mybuyerInfo);
          setActivePaymentBtn(isValid);
          if (
            mybuyerInfo.EmailID !== null &&
            mybuyerInfo.EmailID !== "" &&
            mybuyerInfo.EmailIDVerified
          ) {
            setEmailEditEnable(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error while fetching details:", err);
      });
  };

  const updateEmailVerificationOnUpdate = () => {
    setEmailEditEnable(true);
    const mybuyerInfo = {
      ...buyerInfo,
      EmailIDVerified: false,
    };
    if (validateEmail(buyerInfo.EmailID)) {
      setEmailOTPbtn(false);
    }
    setBuyerInfo(mybuyerInfo);
    const isValid = checkPaymentEnable(mybuyerInfo);
    setActivePaymentBtn(isValid);
  };

  const handleModalVisible = () => {
    setIsModalVisible(false);
  };

  const handleSuccessModalVisible = () => {
    setSuccessModalVisible(false);
  };

  const handleLeadSubmit = () => {
    SubmitFAFLeads();
  };

  const handleLeadbuyerInfo = (field, e) => {
    let val = e.target.value;
    setLeadBuyerInfo((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const SubmitFAFLeads = () => {
    const reqBuyerInfo = {
      ...leadBuyerInfo,
    };

    if (
      reqBuyerInfo.BuyerName !== "" &&
      reqBuyerInfo.BuyerName !== null &&
      reqBuyerInfo.MobileNo.length === 10 &&
      validateMobile(reqBuyerInfo.MobileNo)
    ) {
      fetch(`${apiBaseURL}/api/FriendAndFamily/SubmitFAFLeads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reqBuyerInfo),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((resultInfo) => {
          setIsModalVisible(false);
          if (resultInfo && resultInfo.resultStatus === "Success") {
            if (resultInfo.resultCode === 0 && resultInfo.result === 1) {
              setSuccessModalVisible(true);
            } else {
              showtoast("error", "Something went wrong while submitting lead.");
            }
          } else if (
            resultInfo &&
            resultInfo.resultStatus === "Failed" &&
            resultInfo.resultCode === -1001
          ) {
            mySweetAlert("error", resultInfo.resultMessage);
          }
        })
        .catch((err) => {
          setIsModalVisible(false);
          console.error("Error while submitting leads:", err);
        })
        .finally(() => {
          if (isTokenValid) {
            setLeadBuyerInfo((prevState) => ({
              ...prevState,
              BuyerName: "",
            }));
          } else {
            setLeadBuyerInfo((prevState) => ({
              BuyerName: "",
              MobileNo: "",
            }));
          }
        });
    } else {
      if (reqBuyerInfo.BuyerName === "" || reqBuyerInfo.BuyerName === null) {
        showtoast("error", "Please provide your name.");
      } else if (
        reqBuyerInfo.MobileNo === null ||
        reqBuyerInfo.MobileNo === ""
      ) {
        showtoast("error", "Please provide mobile number.");
      } else if (
        reqBuyerInfo.MobileNo.length !== 10 ||
        !validateMobile(reqBuyerInfo.MobileNo)
      ) {
        showtoast("error", "Please provide valid mobile number.");
      }
    }
  };

  useEffect(() => {
    if (isTokenValid && reqParams.MobileNo.length === 10) {
      getBuyerdetails(reqParams);

      setLeadBuyerInfo((prevState) => ({
        ...prevState,
        MobileNo: reqParams && reqParams.MobileNo,
      }));
    }
  }, [reqParams.MobileNo]);

  return (
    <div className="containerCustomerInfoMain">
      <nav className="navbar navbar-expand-lg custom-navbar navbar-FF">
        <div className="container-fluid mobile-res-clss">
          <a className="navbar-brand custom-logo" href="https://www.vzy.one/">
            <img
              src="images/logo.svg"
              alt="My Logo"
              className="img-fluid clas-of-logo"
            />
          </a>
        </div>
      </nav>
      <div className="container-fluid friendsFamily">
        <div className="row">
          <CustomerInfo
            generateMobileOTP={(e, mobNo) => generateMobileOTP(e, mobNo)}
            oTPSentResult={oTPSentResult}
            oTPbtn={oTPbtn}
            verifyMobileOTP={(e, inputOTP, mobNo) =>
              verifyMobileOTP(e, inputOTP, mobNo)
            }
            oTPVerifyResult={oTPVerifyResult}
            isOTPInputVisible={isOTPInputVisible}
            generateEmailOTP={(e, emailId) => generateEmailOTP(e, emailId)}
            emailOTPSentResult={emailOTPSentResult}
            emailOTPbtn={emailOTPbtn}
            verifyEmailOTP={(e, inputEmailOTP, emailId) =>
              verifyEmailOTP(e, inputEmailOTP, emailId)
            }
            emailOTPVerifyResult={emailOTPVerifyResult}
            isEmailOTPInputVisible={isEmailOTPInputVisible}
            updateBuyerInfo={updateBuyerInfo}
            buyerInfo={buyerInfo}
            isEmailAlreadyVerified={buyerInfo.EmailIDVerified}
            emailOTPCountdn={emailOTPCountdn}
            otpCountdn={otpCountdn}
            isTokenValid={isTokenValid}
            reqParams={reqParams}
            emailEditEnable={emailEditEnable}
            updateEmailVerificationOnUpdate={updateEmailVerificationOnUpdate}
          />
          <PaymentInfo
            allCartSummary={allCartSummary}
            finalCart={finalCart}
            handleMakePayment={handleMakePayment}
            activePaymentBtn={activePaymentBtn}
            setIsModalVisible={setIsModalVisible}
          />
        </div>
      </div>

      {isModalVisible && (
        <LeadSubmitDetails
          handleLeadbuyerInfo={handleLeadbuyerInfo}
          leadBuyerInfo={leadBuyerInfo}
          handleLeadSubmit={handleLeadSubmit}
          handleModalVisible={handleModalVisible}
        />
      )}
      {successModalVisible && (
        <LeadSuccessModal
          handleSuccessModalVisible={handleSuccessModalVisible}
        />
      )}
    </div>
  );
};
